"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    ListOfDifferentTrips: ()=>ListOfDifferentTrips
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_MyTripsList_js_namespaceObject = require("./MyTripsList.js");
const external_myTripDataContext_js_namespaceObject = require("./myTripDataContext.js");
const TripsHeader = ({ title, isRealTime })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
        fontWeight: "bold",
        my: 2,
        color: isRealTime ? 'text.lightest' : 'text.dark',
        children: title
    });
const ListOfDifferentTrips = ()=>{
    const { currentTrips, upcomingTrips, pastTrips, canceledTrips } = (0, external_react_namespaceObject.useContext)(external_myTripDataContext_js_namespaceObject.myTripContextData);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
        children: [
            currentTrips?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TripsHeader, {
                        title: "Your current trip"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_MyTripsList_js_namespaceObject.MyTripsList, {
                            trips: currentTrips,
                            tripCategory: "currentTrips"
                        })
                    })
                ]
            }),
            upcomingTrips?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TripsHeader, {
                        title: "Upcoming trip(s)"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_MyTripsList_js_namespaceObject.MyTripsList, {
                            trips: upcomingTrips,
                            tripCategory: "upcomingTrips"
                        })
                    })
                ]
            }),
            pastTrips?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TripsHeader, {
                        title: "Past trip(s)"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_MyTripsList_js_namespaceObject.MyTripsList, {
                            trips: pastTrips,
                            tripCategory: "pastTrips"
                        })
                    })
                ]
            }),
            canceledTrips?.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(TripsHeader, {
                        title: "Cancelled trip(s)"
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Box, {
                        maxWidth: "450px",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_MyTripsList_js_namespaceObject.MyTripsList, {
                            trips: canceledTrips,
                            tripCategory: "canceledTrips"
                        })
                    })
                ]
            })
        ]
    });
};
exports.ListOfDifferentTrips = __webpack_exports__.ListOfDifferentTrips;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ListOfDifferentTrips"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
